export default __webpack_public_path__ + "static/gewerbestrom-8a52b4ece4e6f80529af5419ffc6de2e.jpg";